/**
 * Centralized color constants for the application
 */

// Network Status Colors
export const NETWORK_STATUS_COLORS = {
  ENABLED: '#00ff9f',    // Mint green - transfer enabled
  DISABLED: '#ff1493',   // Hot pink/DeepPink - transfer disabled
  UNKNOWN: '#ffaa00',     // Yellow/Orange - status unknown
} as const;

// Profit Colors (from formatters.ts)
export const PROFIT_COLORS = {
  HIGH: '#ff00ff',        // Magenta for >= 10%
  MEDIUM: '#00ffff',      // Cyan for >= 5%
  LOW: '#00ff9f',         // Mint green for >= 2%
  MINIMAL: '#ffaa00',     // Orange for >= 1%
  NEGLIGIBLE: '#888888',  // Gray for < 1%
} as const;

// Additional theme colors
export const THEME_COLORS = {
  BACKGROUND_OVERLAY: 'rgba(0, 0, 0, 0.3)',
  TEXT_SECONDARY: 'rgba(255, 255, 255, 0.45)',
  DIVIDER: 'rgba(255, 255, 255, 0.12)',
} as const;